import { OrderDto } from '@trucktrax/trucktrax-ts-common';

/**
 * Pick one order id per unique jobsite circle (center + radius + color).
 * Each JobsiteMarker draws its own Circle at fillOpacity 0.25; many orders
 * often share one jobsite, and stacked fills look fully opaque.
 */
export function selectJobsiteGeofenceOwnerIds(
  orders: OrderDto[],
  plantColors?: Record<string, string>,
): Set<string> {
  const owners = new Set<string>();
  const seen = new Set<string>();

  orders.forEach(order => {
    const circle = order.geoZone?.zone?.circle;
    const center = circle?.center;
    if (
      center?.latitude == null ||
      center?.longitude == null ||
      circle?.radius == null ||
      order.id == null
    ) {
      return;
    }

    const color = (plantColors && plantColors[order.plant?.url ?? '']) || '';
    const key = `${center.latitude}|${center.longitude}|${circle.radius}|${color}`;
    if (seen.has(key)) {
      return;
    }
    seen.add(key);
    owners.add(String(order.id));
  });

  return owners;
}
